<template>
  <Qr />
</template>

<script>
import Qr from "../components/namya/qr_signin.vue";

export default {
  name: "Homes",

  components: {
    Qr,
  },
};
</script>
